import { useState, useEffect } from 'react';
import { useViewportWidth } from '../MofaCarousel';


export const useMaxWidthFunc = (numberOfOffers: number) => {

  const viewportWidth = useViewportWidth();
  const [ useMaxWidth, setUseMaxWidth ] = useState(null);

  useEffect(()=>{
    if(viewportWidth < 1920) {
      setUseMaxWidth(true);
    } else {
      if(numberOfOffers < 4) {
        setUseMaxWidth(true);
      } else {
        setUseMaxWidth(false);
      }
    }
  }, [viewportWidth]);

  return { useMaxWidth };
};
